import { render } from "./TrackEditButton.vue?vue&type=template&id=b569faca&ts=true"
import script from "./TrackEditButton.vue?vue&type=script&lang=ts"
export * from "./TrackEditButton.vue?vue&type=script&lang=ts"

import "./TrackEditButton.vue?vue&type=style&index=0&id=b569faca&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__